import React from 'react'
import Head from '../components/Head'
import Header from '../components/Header'
import Intro from '../components/IntroFAQ'
import Footer from '../components/footer'
import FAQ from '../good_components/FAQ'

const faq = require('../data/faq.json')

export default class extends React.Component {
  render() {
    return (
      <React.Fragment>
        <Head
          title="PlayVS | Frequently Asked Questions"
          description="PlayVS is the official high school esports league, sanctioned by the NFHS. Play with your friends, compete for your school, and win the state championship."
          keywords="high school esports"
        />

        <Header />

        <Intro />

        <section>
          <div className="container">
              <div className="section__body">
                <div className="row--thinner">
                  <div className="column--whole">
                    {faq.map(f => {
                      return (
                        <FAQ
                          q={f.q}
                          a={f.a}
                        />
                      )
                    })}
                  </div>
                </div>
              </div>
            </div>
        </section>

        <Footer />

      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/common/ui/pages/faq.js